module.exports = __webpack_public_path__ + "static/media/PR_55_02.537443eb.jpg";